/* ==========================================================================
   NABAT - sticky Add-to-bag gate                  (nabat-sticky-atc-gate.js)

   Shows the sticky bottom buy bar only after the in-page "Add to bag"
   button has scrolled out of view, so the product page never renders two
   filled primary CTAs at once. Pairs with nabat-sticky-atc-gate.css.

   Contract with the stylesheet:
     body.nb-atc-gate-ready  - the observer is running; CSS may act.
     body.nb-atc-inview      - the in-page button is currently on screen.

   Fail-safe: every early return leaves `nb-atc-gate-ready` off, which makes
   the stylesheet inert and the bar always visible - today's behaviour. The
   gate can only ever hide the bar while a real, connected, on-screen
   in-page buy button exists.

   Nothing here touches the form, its inputs, its variant picker or its
   submit handler. It only toggles two class names on <body>.
   ========================================================================== */
(function () {
  'use strict';

  /* The snippet that loads this file can render more than once on a page. */
  if (window.__nabatAtcGate) return;
  window.__nabatAtcGate = true;

  if (!('IntersectionObserver' in window)) return;

  var READY = 'nb-atc-gate-ready';
  var INVIEW = 'nb-atc-inview';
  var BUTTON = '.featured-product__add-to-cart-button';
  var BAR = '.product-sticky-quick-add';

  var target = null;
  var io = null;

  function inViewportNow(el) {
    var r = el.getBoundingClientRect();
    var h = window.innerHeight || document.documentElement.clientHeight;
    var w = window.innerWidth || document.documentElement.clientWidth;
    return r.bottom > 0 && r.top < h && r.right > 0 && r.left < w;
  }

  /* The sticky bar's own button uses a different class, but scope anyway so
     this can never latch onto the very element it is gating. */
  function findInPageButton() {
    var nodes = document.querySelectorAll(BUTTON);
    for (var i = 0; i < nodes.length; i++) {
      if (!nodes[i].closest(BAR)) return nodes[i];
    }
    return null;
  }

  function disarm() {
    if (io) { io.disconnect(); io = null; }
    target = null;
    document.body.classList.remove(INVIEW);
    document.body.classList.remove(READY);
  }

  function arm() {
    var el = findInPageButton();

    /* No in-page button (or it was removed) -> hand the page back to the
       theme's own behaviour rather than guessing. */
    if (!el) { disarm(); return; }
    if (el === target && io) return;

    if (io) io.disconnect();
    target = el;

    io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        document.body.classList.toggle(INVIEW, entries[i].isIntersecting);
      }
    }, { threshold: 0 });

    io.observe(target);

    /* Resolve the first state synchronously. The observer's own first
       callback is async, and without this the bar would flash on at the
       top of the page before being gated. */
    document.body.classList.toggle(INVIEW, inViewportNow(target));
    document.body.classList.add(READY);
  }

  function boot() {
    /* Only product pages that actually render the bar are of interest. */
    if (!document.querySelector(BAR)) return;

    arm();

    /* product-info.js can replace <main> wholesale on a product swap and
       rewrites the quick-add container on a variant change, which detaches
       the observed button. Without this the class would freeze and the bar
       could stay hidden for good. */
    if (!('MutationObserver' in window)) return;

    var queued = false;
    var mo = new MutationObserver(function () {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(function () {
        queued = false;
        if (!target || !target.isConnected) arm();
      });
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
